const variants = {
  "destructive": "destructive",
}

class BadgeCard extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.render();

    this.titleElement = this.shadowRoot.querySelector("span");
  }

  static get observedAttributes() {
    return ['title', 'variant'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'title') this.title = newValue;
    if (name == 'variant') this.variant = newValue;
  }

  set title(val) {
    this.titleElement.innerHTML = val;
  }

  set variant(val) {
    this.titleElement.classList.add(variants[val]);
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>${this.css().trim()}</style>
      ${this.template().trim()}
    `
  }

  css() {
    return `
      :host {
        width: max-content;
        height: auto;
        background: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      span {
        font-family: "GT America", sans-serif;
        font-size: 14px;
        font-weight: 400;
        line-height: 16.8px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 8px 11px;
        border-radius: 9999px;
      }

      .destructive {
        border: 1px solid #CD201F;
        color: #CD201F;
      }
    `;
  }

  template() {
    return `
      <span>${this.title}</span>
    `;
  }
}

customElements.define("x-badge-card", BadgeCard);
